export default __webpack_public_path__ + "656a2aa9aa3e7ca1b91ac3a15b461397.jpg";